import * as actionTypes from './auditLogActionType';
import { TaxInvoiceLogRequest, TaxInvoiceLogResponse } from 'routes/main/taxInvoice/types';

export const taxInvoiceLogRequest = (
  payload: TaxInvoiceLogRequest
): actionTypes.TaxInvoiceLogRequestAction => {
  return {
    type: actionTypes.TAX_INVOICE_LOG_REQUEST,
    payload,
  };
};

export const taxInvoiceLogSuccess = (
  payload: TaxInvoiceLogResponse
): actionTypes.TaxInvoiceLogSuccessAction => {
  return {
    type: actionTypes.TAX_INVOICE_LOG_SUCCESS,
    payload,
  };
};

export const taxInvoiceLogError = (
  message: string,
  error?: any
): actionTypes.TaxInvoiceLogErrorAction => {
  return {
    type: actionTypes.TAX_INVOICE_LOG_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const taxInvoiceLogReset = (): actionTypes.TaxInvoiceLogResetAction => {
  return {
    type: actionTypes.TAX_INVOICE_LOG_RESET,
  };
};
